import { DocumentGeneric } from 'dashboard/models/document';
import { Tag } from 'dashboard/models/tag';
import { User } from 'dashboard/models/user';
import { Verification } from 'dashboard/models/verification';
import { VerificationActions, VerificationActionType } from 'dashboard/redux/actions/verification';

export interface VerificationState {
  redactor: User | undefined;
  verification: Verification | undefined;
  document: DocumentGeneric | undefined;
  tags: Tag[];
}

export const initialState: VerificationState = {
  redactor: undefined,
  verification: undefined,
  document: undefined,
  tags: [],
};

const verificationReducer = (
  state: VerificationState = initialState,
  action: VerificationActions,
): VerificationState => {
  switch (action.type) {
    case VerificationActionType.ClearVerification: {
      return initialState;
    }

    case VerificationActionType.SetVerification: {
      return {
        ...state,
        verification: action.payload.verification,
      };
    }

    case VerificationActionType.SetVerificationDetails: {
      return {
        ...state,
        redactor: action.payload.redactor,
        document: action.payload.document,
        tags: action.payload.tags,
      };
    }

    default:
      return state;
  }
};

export default verificationReducer;
